import React, { FC } from 'react';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';

import { AddIcon } from 'src/shared/components';
import { PermissionsEnums } from 'src/shared/enums';
import { ComponentWithPermissions } from 'src/shared/hocs';
import { useTranslate } from 'src/shared/providers';

import { EmployeeAvailabilityCycleInfoTable } from './EmployeeAvailabilityCycleInfoTable';
import { EmployeeAvailabilityCyclePreferencesTable } from './EmployeeAvailabilityCyclePreferencesTable';
import { useEmployeeAvailabilityAddCycle } from './providers/EmployeeAvailabilityAddCycleProvider';
import { useEmployeeAvailabilityRecurringCycle } from './providers/EmployeeAvailabilityRecurringCycleProvider';

export const EmployeeAvailabilityRecurringCycleSection: FC = () => {
  const { t } = useTranslate();

  const { onAdd: handleAddCycle } = useEmployeeAvailabilityAddCycle();

  const {
    inputs,
    editedPeriodDate,
    touched,
    errors,
    loading,
    updating,
    apiError,
    onCancel,
    onChangeFullDay,
    onChangeStatus,
    onDelete,
    onAdd,
    onChangeStartTime,
    onChangeEndTime,
    onSave,
    onEditedChange,
    onDeleteDate,
  } = useEmployeeAvailabilityRecurringCycle();

  return (
    <Stack direction="column" gap={2} pb={1}>
      {apiError && <Alert severity="error">{apiError}</Alert>}

      <EmployeeAvailabilityCycleInfoTable cycle={inputs} loading={loading} readOnly />

      <EmployeeAvailabilityCyclePreferencesTable
        inputs={inputs}
        editedPeriodDate={editedPeriodDate}
        touched={touched}
        errors={errors}
        loading={loading}
        updating={updating}
        onEditingChange={onEditedChange}
        onCancel={onCancel}
        onChangeFullDay={onChangeFullDay}
        onChangeStatus={onChangeStatus}
        onDelete={onDelete}
        onAdd={onAdd}
        onChangeStartTime={onChangeStartTime}
        onChangeEndTime={onChangeEndTime}
        onSave={onSave}
        onDeleteDate={onDeleteDate}
      />

      <Divider />

      <ComponentWithPermissions permissions={PermissionsEnums.WORK_TIME_PREFERENCES_EDIT}>
        {!editedPeriodDate && (
          <Button
            sx={{ marginTop: 3, alignSelf: 'flex-start' }}
            size="small"
            startIcon={<AddIcon size={20} />}
            color="secondary"
            onClick={handleAddCycle}
          >
            {t('availability.addCycle')}
          </Button>
        )}
      </ComponentWithPermissions>
    </Stack>
  );
};
